import React from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import style from './Properties.module.scss';
import OwlCarousel from 'react-owl-carousel';
import {numberWithCommas, timeAgo} from "../../../../helper/functions";
import {Carousel, Container} from "react-bootstrap";
import {BASE_URL} from "../../../../environment/environment";
import * as urls from "../../../../config/urls";
import noImage from "../../../../asset/images/icon/no-image-icon.png";
import propertyTypes from "../../../../asset/data/propertyTypes";
import transactionTypes from "../../../../asset/data/transactionTypes";
import history from "../../../../helper/history";

class Properties extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      options: {
        loop: true,
        margin: 35,
        nav:false,
        responsive:{
          0: {
            items: 1,
          },
          1120: {
            items: 2,
          },
          1700: {
            items: 3,
          },
        },
      },
    }
  }

  redirect(propertyId) {
    history.push(`/advanced-search/${propertyId}`);
  }

  render() {
    const {properties} = this.props;
    return (
      <Container className={`search-container`}>
        <h2 className={`section-title ${style.title}`}>فایل های مشاور</h2>
        <div className={style.properties_container}>
          {
            properties && !!properties.length && (
              <OwlCarousel className="owl-theme" {...this.state.options}>
                {
                  properties.map((item, index) => {
                    return (
                        <div key={index} className={`mb-4 ${style.property_boxContainer}`} onClick={() => {
                          this.redirect(item.id)
                        }}>
                          <div className={`${style.property_box}`}>
                            <div className={`${style.property_img}`}>
                              {
                                item.files && item.files.length ? (
                                    <Carousel className={style.carousel} indicators={false} controls={item.files.length > 1}>
                                      {
                                        item.files.map((file, index) => {
                                          return (
                                              <Carousel.Item key={index}>
                                                <img className={`d-block w-100 ${style.property_carousel_image}`}
                                                     src={`${BASE_URL}${urls.FILE_BY_UUID}/${file}?size=thumbnails`}
                                                     alt="file"
                                                />
                                              </Carousel.Item>
                                          )
                                        })
                                      }
                                    </Carousel>
                                ) : (
                                    <img className={style.property_image} src={noImage} alt="file" />
                                )
                              }
                              <div className={`${style.property_situation}`}>
                                <span>{propertyTypes.find((tt) => tt.value === item.propertyType).label}</span>
                                &nbsp;
                                <span>{transactionTypes.find((tt) => tt.value === item.transactionType).label}</span>
                              </div>
                              {
                                item.propertyCode && (
                                    <div className={`${style.property_code}`}>
                                      <span>{item.propertyCode}</span>
                                    </div>
                                )
                              }
                            </div>
                            <div className={`pr-3 pl-3 ${style.content_container}`}>
                              <div className={`${style.property_title} d-flex justify-content-between align-items-center`}>
                                <span>{item.propertyName}</span>
                                {/*<i className={'icon-bookmark-empty'} />*/}
                              </div>
                              <div className={`d-flex flex-column justify-content-between ${style.property_details}`}>
                                <div className={'d-flex align-items-center'}>
                                  <i className={'icon-meter'} />
                                  <span>متراژ:</span>
                                  <span className={`${style.value}`}>{item.foundation} متر</span>
                                </div>
                                <div className={'d-flex align-items-center'}>
                                  <i className={'icon-beds'} />
                                  <span>تعداد خواب:</span>
                                  <span className={`${style.value}`}>{item.propertyBedrooms ? item.propertyBedrooms : '-'}</span>
                                </div>
                                <div className={'d-flex align-items-center'}>
                                  <i className={'icon-pin'} />
                                  <span>{item.address || 'آدرس وارد نشده است'}</span>
                                </div>
                              </div>
                              <div className={`${style.property_footer}`}>
                                <div className={'d-flex justify-content-between'}>
                                  <span>قیمت:</span>
                                  <span>
                                    <span className={`${style.property_price}`}>{item.overallPrice ? numberWithCommas(item.overallPrice) : 'توافقی'} </span>
                                      {item.overallPrice ? 'تومان' : ''}
                                    </span>
                                </div>
                                <div>
                                  <span>{timeAgo(item.changedDate)}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                    )
                  })
                }
              </OwlCarousel>
            )
          }
        </div>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Properties));
